if(!customElements.get('shop-the-look-banner')) {
  class ShopTheLookBanner extends HTMLElement {
    constructor() {
      super();
      this.bindOnButtonTrigger = this.onButtonTrigger.bind(this);
      this.bindSetButtonsEvents = debounce(this.setButtonsEvents.bind(this), 200);
    }

    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.shop-the-look-banner__button'));
      this.cards = Array.from(this.querySelectorAll('.shop-the-look-banner-card'));
      this.medias = Array.from(this.querySelectorAll('.shop-the-look-banner__product-media'));
      this.currentBreackpoint = null;

      this.setButtonsEvents();
      window.addEventListener('resize', this.bindSetButtonsEvents);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.bindSetButtonsEvents);
      this.buttons.forEach(button => {
        button.removeEventListener('mouseenter', this.bindOnButtonTrigger);
        button.removeEventListener('click', this.bindOnButtonTrigger);
      })
    }

    onButtonTrigger(event) {
      const trigger = event.target.closest('.shop-the-look-banner__button');

      this.buttons.forEach((button) => {
        button.classList.toggle('active', button === trigger);
      })
      this.cards.forEach((card) => {
        card.classList.toggle('active', card.id === trigger.dataset.card);
      })
      this.medias.forEach((media) => {
        media.classList.toggle('active', media.dataset.card === trigger.dataset.card);
      })
    }

    setButtonsEvents() {
      if (window.innerWidth >= 750 && this.currentBreackpoint != 'desktop') {
        this.buttons.forEach((button) => {
          button.addEventListener('mouseenter', this.bindOnButtonTrigger);
          button.removeEventListener('click', this.bindOnButtonTrigger);
          this.currentBreackpoint = 'desktop';
        })
      } else if (window.innerWidth < 750 && this.currentBreackpoint != 'mobile') {
        this.buttons.forEach((button) => {
          button.addEventListener('click', this.bindOnButtonTrigger);
          button.removeEventListener('mouseenter', this.bindOnButtonTrigger);
          this.currentBreackpoint = 'mobile';
        })
      }
    }
  }

  customElements.define('shop-the-look-banner', ShopTheLookBanner)
}